import React from "react";

export const AppContext = React.createContext({
  //flag which indicates wether some promise is currently in progress, i.e. has not finished yet
  promiseInProgress: false,

  //if needed, contains reference to HTML input element which needs to be autofocused
  afInput: undefined
});
